module.exports = __webpack_public_path__ + "static/media/card-6.5a237853.png";